module.exports = __webpack_public_path__ + "../resources/img/new_icons.d3802ecb.png";